/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

type HighlightPart = {
  text: string;
  isMatch: boolean;
};

export const getHighlightParts = (
  text: string,
  searchTerm: string
): HighlightPart[] => {
  if (!searchTerm.trim()) {
    return [{ text, isMatch: false }];
  }

  const escapedTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedTerm})`, 'gi');
  const parts = text.split(regex).filter(Boolean);

  return parts.map((part) => ({
    text: part,
    isMatch: regex.test(part),
  }));
};
